import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::store
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:97
 * @route '/login/help/two-factor/confirm'
 */
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/login/help/two-factor/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::store
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:97
 * @route '/login/help/two-factor/confirm'
 */
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::store
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:97
 * @route '/login/help/two-factor/confirm'
 */
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::store
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:97
 * @route '/login/help/two-factor/confirm'
 */
    const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: store.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::store
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:97
 * @route '/login/help/two-factor/confirm'
 */
        storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: store.url(options),
            method: 'post',
        })
    
    store.form = storeForm
const confirm = {
    store: Object.assign(store, store),
}

export default confirm